import { css } from 'styled-components';
import { PinCodeFooterProps } from './models';

export const PinCodeFooter = css<PinCodeFooterProps>(({ theme }) => {
  return css`
    width: 100%;
    flex: 1 0 0;
    gap: 8px;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    > .resend-verification-link {
      text-decoration: underline;
      color: ${theme.colors.brightBlue};
      font-size: 14px;
      line-height: 21px;

      &.disabled {
        text-decoration: none;
        color: ${theme.colors.primaryDeepBlue};
      }
    }

    > .resend-timer {
      font-size: 14px;
      line-height: 21px;
      color: ${theme.colors.mediumGray};
    }
  `;
});
